// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2r9gp","content":"GlobalSearch_content__3oZOG"};